import { useCallback, useState } from "react"

export function useMap<T = any>(source?: Map<string, T>) {
  const [map, setMap] = useState<Map<string, T>>(source ?? new Map<string, T>())

  const set = useCallback((key: string, value: T) => {
    setMap((prev) => {
      const next = new Map(prev)
      next.set(key, value)
      return next
    })
  }, [])

  const setMany = useCallback((entries: Iterable<[string, T]>) => {
    setMap((prev) => {
      const next = new Map(prev)
      for (const [k, v] of entries) next.set(k, v)
      return next
    })
  }, [])

  const remove = useCallback((key: string) => {
    setMap((prev) => {
      if (!prev.has(key)) return prev
      const next = new Map(prev)
      next.delete(key)
      return next
    })
  }, [])

  const clear = useCallback(() => {
    setMap(new Map<string, T>())
  }, [])

  const get = useCallback((key: string) => map.get(key), [map])
  const has = useCallback((key: string) => map.has(key), [map])

  return {
    get,
    has,
    set,
    clear,
    remove,
    setMany,
  }
}
